<template>
<section class="hero-section relative overflow-hidden" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <div class="hero-overlay"></div>
    <div class="relative flex flex-col items-center justify-center h-full text-center px-6">
      <span class="eyebrow eyebrow-light mb-5">Salón de Belleza</span>
      <h1 class="hero-title text-5xl md:text-7xl lg:text-8xl text-white font-bold">Jeshu Beauty</h1>
      <span class="divider-line divider-line-light mt-6"></span>
      <p class="text-base md:text-2xl mt-6 max-w-2xl text-white/95 font-light italic">
        Servicios personalizados y adaptados a tu estilo
      </p>
    </div>
  </section>

  <section class="grid grid-cols-1 md:grid-cols-2 gap-12 mt-24 px-6 md:px-16 items-center">
    <div class="flex flex-col items-center justify-center">
      <span class="eyebrow mb-4">Temporada 2026</span>
      <h2 class="font-display text-4xl md:text-5xl lg:text-6xl text-purple-custom text-center font-semibold">
        Tendencias<br>
        <span class="italic font-medium">Primavera / Verano</span>
      </h2>
      <span class="divider-line mt-6"></span>
      <p class="text-base sm:text-lg md:text-xl text-gray-700 text-center pt-10 leading-relaxed">
        Explora nuestra selección de imágenes inspiradas en las últimas tendencias de belleza para primavera/verano. Cada foto refleja estilo, creatividad y elegancia, pensados para realzar lo mejor de esta temporada. Déjate inspirar por los colores, texturas, relieves y acabados que marcarán esta temporada 🌸.
      </p>
      <p class="font-display italic text-purple-custom text-xl md:text-2xl text-center pt-6">
        «La belleza está en los detalles»
      </p>
    </div>
    <div class="carousel-frame">
      <CarouselPersonalizado
        :autoplay="4000"
        :wrap-around="true"
        :pause-on-hover="true"
        :items-to-show="1"
        class="w-full h-full"
      >
        <SlidePersonalizado v-for="item in itemsTemporada" :key="item">
          <img :src="item.src" :alt="item.alt" class="object-cover rounded-2xl w-full h-full sm:h-[600px] h-[400px]" />
        </SlidePersonalizado>
      </CarouselPersonalizado>
    </div>
  </section>

  <section class="services-band relative mt-24 py-20 px-6 flex flex-col items-center justify-center overflow-hidden">
    <div class="services-band-pattern"></div>
    <div class="relative z-10 flex flex-col items-center text-center max-w-3xl">
      <span class="eyebrow eyebrow-light mb-4">Reserva tu cita</span>
      <h2 class="font-display text-4xl sm:text-5xl md:text-6xl text-white font-semibold mb-4">
        Servicios
      </h2>
      <span class="divider-line divider-line-light mb-6"></span>
      <p class="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed mb-8">
        Reserva tu hora y vive una experiencia única con mis servicios personalizados diseñados especialmente para ti.
      </p>
      <a href="https://jeshubeauty.setmore.com/"
         class="btn-on-purple"
         @mouseenter="isHovered = true"
         @mouseleave="isHovered = false">
          Agendar Cita
          <img v-show="!isHovered" src="../assets/pencil-svgrepo-com.svg" alt="Calendario" class="w-5 h-5" />
          <img v-show="isHovered" src="../assets/pencil-svgrepo-com2.svg" alt="Calendario" class="w-5 h-5" />
      </a>
    </div>
  </section>




  <section class="container mx-auto py-24 px-4 max-w-7xl">
    <div class="text-center mb-14">
      <span class="eyebrow mb-3">Nuestros servicios</span>
      <h2 class="font-display text-4xl md:text-5xl text-purple-custom font-semibold mt-3">
        Belleza a tu medida
      </h2>
      <span class="divider-line mt-5 mx-auto block"></span>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-10">
      <article class="service-card card-lift">
        <div class="service-card-media">
          <CarouselPersonalizado :autoplay="4000" :wrap-around="true" :pause-on-hover="true">
            <SlidePersonalizado v-for="item in itemsManicure" :key="item">
              <img :src="item.src" :alt="item.alt" class="service-card-img" />
            </SlidePersonalizado>
          </CarouselPersonalizado>
        </div>
        <h3 class="font-display text-2xl md:text-3xl text-purple-custom font-semibold">Manicure y Pedicure</h3>
        <span class="divider-line mt-3 mb-4 block mx-auto" style="width: 40px;"></span>
        <p class="text-gray-700 text-base leading-relaxed">
          ¡Tu cuidado personal es nuestra prioridad! Los servicios de manicure y pedicure están diseñados para realzar la belleza y salud de tus manos y pies. Se utilizan productos profesionales para garantizar un acabado impecable y duradero.
        </p>
      </article>

      <article class="service-card card-lift">
        <div class="service-card-media">
          <CarouselPersonalizado :autoplay="4000" :wrap-around="true" :pause-on-hover="true">
            <SlidePersonalizado v-for="item in itemsMaquillaje" :key="item">
              <img :src="item.src" :alt="item.alt" class="service-card-img" />
            </SlidePersonalizado>
          </CarouselPersonalizado>
        </div>
        <h3 class="font-display text-2xl md:text-3xl text-purple-custom font-semibold">Maquillaje Novias y Social</h3>
        <span class="divider-line mt-3 mb-4 block mx-auto" style="width: 40px;"></span>
        <p class="text-gray-700 text-base leading-relaxed">
          Te acompaño en tus momentos especiales. Entiendo la importancia de lucir radiante en las ocasiones más significativas, por eso ofrezco maquillaje para novias y eventos sociales, diseñado para resaltar tu belleza natural con técnicas avanzadas y productos de alta calidad.
        </p>
      </article>

      <article class="service-card card-lift">
        <div class="service-card-media">
          <CarouselPersonalizado :autoplay="4000" :wrap-around="true" :pause-on-hover="true">
            <SlidePersonalizado v-for="item in itemsPeinados" :key="item">
              <img :src="item.src" :alt="item.alt" class="service-card-img" />
            </SlidePersonalizado>
          </CarouselPersonalizado>
        </div>
        <h3 class="font-display text-2xl md:text-3xl text-purple-custom font-semibold">Peinados</h3>
        <span class="divider-line mt-3 mb-4 block mx-auto" style="width: 40px;"></span>
        <p class="text-gray-700 text-base leading-relaxed">
          Hago realidad el peinado de tus sueños. Realizo peinados personalizados para cada ocasión, ya sea un evento, una celebración o momento especial. Creo el look perfecto que complementa tu estilo con técnicas modernas para un acabado increíble.
        </p>
      </article>
    </div>
  </section>


  <section class="quien-soy-band relative py-20 px-4 overflow-hidden">
    <div class="container mx-auto flex flex-col md:flex-row items-center max-w-6xl gap-12 relative z-10">
      <div class="md:w-1/2 text-center md:text-left">
        <span class="eyebrow eyebrow-light mb-3">Sobre mí</span>
        <h2 class="font-display text-3xl md:text-5xl text-white font-semibold mt-3 mb-5 text-center md:text-left">Quien Soy</h2>
        <span class="divider-line divider-line-light mb-6 block mx-auto md:mx-0"></span>
        <p class="text-white/95 leading-relaxed text-justify text-sm md:text-lg">
          Una mujer profesional apasionada por el diseño y el estilo, enfocada en el rubro de la belleza para entregarte servicios personalizados acorde a tus necesidades. Aunque mi enfoque principal son las uñas. Me enorgullece brindarte una experiencia que te haga sentir cómoda, hermosa y segura. Estoy al tanto de las últimas tendencias, manteniéndome siempre a la vanguardia, y me esfuerzo por superar tus expectativas con resultados impresionantes que reflejen tu estilo personal.
        </p>
      </div>

      <div class="md:w-1/2 flex justify-center">
        <div class="portrait-frame">
          <img
            src="../assets/quiensoy2.jpg"
            alt="Quien soy"
            class="portrait-image"
          />
        </div>
      </div>
    </div>
  </section>

  <section class="grid grid-cols-1 md:grid-cols-2 gap-12 mt-24 mb-20 px-4 md:px-20 items-center">
    <div class="flex flex-col justify-center max-w-2xl">
      <span class="eyebrow mb-3">Visítanos</span>
      <h2 class="font-display text-3xl md:text-4xl text-purple-custom font-semibold mt-3 mb-4">
        Ubicación
      </h2>
      <span class="divider-line mb-6"></span>
      <p class="text-gray-700 leading-relaxed text-base md:text-lg">
        Mi salón está diseñado para ofrecerte un ambiente acogedor y profesional, pensado en brindarte una experiencia única y personalizada. Ven y déjame ser parte de tu rutina de belleza, donde cada detalle está enfocado en tu comodidad y satisfacción.
      </p>
    </div>

    <div class="map-wrapper">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3328.3141156626743!2d-70.76430072357549!3d-33.467171798370074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c3f50c81c903%3A0xcf9eec914c983faf!2sJeshu%20Beauty!5e0!3m2!1ses-419!2scl!4v1734902190488!5m2!1ses-419!2scl"
        width="100%"
        height="420"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </section>


  <GoContacto />
</template>
 
  <script>

import backgroundImage from '@/assets/cristal1-scaled.jpg';
import GoContacto from '@/components/GoContacto.vue';
import CarouselPersonalizado from '@/components/CarouselPersonalizado.vue';
import SlidePersonalizado from '@/components/SlidePersonalizado.vue';

import { useHead } from '@vueuse/head';
  export default {
    components: {
      GoContacto,
      CarouselPersonalizado,
      SlidePersonalizado
  },
    name: 'PaginaInicio',
    setup() {
    useHead({
      title: 'Jeshu Beauty | ¡Servicios personalizados y adaptados a tu estilo!',
      meta: [
        { name: 'description', content: 'En Jeshu Beauty, realzamos tu belleza única con servicios personalizados y adaptados a tu estilo. Nuestro equipo de expertos combina creatividad y profesionalismo para hacerte lucir y sentir increíble.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: 'Jeshu Beauty | ¡Servicios personalizados y adaptados a tu estilo!' },
        { property: 'og:description', content:  'En Jeshu Beauty, realzamos tu belleza única con servicios personalizados y adaptados a tu estilo. Nuestro equipo de expertos combina creatividad y profesionalismo para hacerte lucir y sentir increíble.' },
        { property: 'og:url', content: 'https://jeshubeauty.cl/' },
      ],
      link:
      [{ rel: 'canonical', href: 'https://jeshubeauty.cl/' }]
    });
  },
    data() {
      return {
        isHovered: false,
        backgroundImage,
        itemsManicure: [
          {src: require("@/assets/Manicure/manicure1.jpg"),alt: "Manicure 1"},
            {src: require("@/assets/Pedicure/pedicure1.jpg"),alt: "Pedicure 1"},

          

        ],
        itemsMaquillaje: [
          {src: require("@/assets/MaquillajePeinado/Maquillaje1.jpg"),alt: "Maquillaje 1"},
          {src: require("@/assets/MaquillajePeinado/Maquillaje2.jpg"),alt: "Maquillaje 2"},

        ],
        itemsPeinados: [
          {src: require("@/assets/MaquillajePeinado/Peinado1.jpg"),alt: "Peinado 1"},
          {src: require("@/assets/MaquillajePeinado/Peinado3.jpg"),alt: "Peinado 2"},

        ],

        itemsTemporada: [
          //{src: require("@/assets/Tendencia/otoño.jpg"),alt: "Tendencia 1"},
          //{src: require("@/assets/Tendencia/otoño2.jpg"),alt: "Tendencia 2"},
          //{src: require("@/assets/Tendencia/otoño3.jpg"),alt: "Tendencia 3"},
          //{src: require("@/assets/Tendencia/otoño4.jpg"),alt: "Tendencia 4"},
          //{src: require("@/assets/Tendencia/otoño5.jpg"),alt: "Tendencia 5"},
          //{src: require("@/assets/Tendencia/otoño6.jpg"),alt: "Tendencia 6"},
          //{src: require("@/assets/Tendencia/otoño7.jpg"),alt: "Tendencia 7"},
          //{src: require("@/assets/Tendencia/otoño8.jpg"),alt: "Tendencia 8"},
          //{src: require("@/assets/Tendencia/otoño9.jpg"),alt: "Tendencia 9"},
          //{src: require("@/assets/Tendencia/otoño10.jpg"),alt: "Tendencia 10"},
          //{src: require("@/assets/Tendencia/otoño11.jpg"),alt: "Tendencia 11"},
          //{src: require("@/assets/Tendencia/otoño12.jpg"),alt: "Tendencia 12"},
          {src: require("@/assets/Tendencia/navidad6.jpg"),alt: "Tendencia 1"},
          {src: require("@/assets/Tendencia/otoño2.jpg"),alt: "Tendencia 2"},
          {src: require("@/assets/Tendencia/navidad1.jpg"),alt: "Tendencia 3"},
          {src: require("@/assets/Tendencia/otoño8.jpg"),alt: "Tendencia 4"},
          {src: require("@/assets/Tendencia/navidad4.jpg"),alt: "Tendencia 5"},
          {src: require("@/assets/Tendencia/otoño10.jpg"),alt: "Tendencia 6"},
          {src: require("@/assets/Tendencia/otoño9.jpg"),alt: "Tendencia 7"},
          {src: require("@/assets/Tendencia/navidad5.jpg"),alt: "Tendencia 8"},
          {src: require("@/assets/Tendencia/otoño12.jpg"),alt: "Tendencia 9"},
          {src: require("@/assets/Tendencia/navidad3.jpg"),alt: "Tendencia 10"},
          {src: require("@/assets/Tendencia/navidad7.jpg"),alt: "Tendencia 11"},

        ]
      };
  },
  }
  
  </script>
  
  <style scoped>
  .hero-section {
    height: 60vh;
    min-height: 480px;
    background-size: cover;
    background-position: center;
  }

  .carousel-frame {
    position: relative;
    border-radius: 1.25rem;
    overflow: hidden;
    box-shadow: 0 18px 48px rgba(115, 74, 145, 0.18);
  }

  .carousel-frame::before {
    content: '';
    position: absolute;
    inset: -8px;
    border: 1px solid rgba(184, 177, 189, 0.5);
    border-radius: 1.5rem;
    pointer-events: none;
    z-index: -1;
  }

  /* Flechas flotantes sobre la imagen también en Tendencias */
  .carousel-frame :deep(.carousel-container) {
    position: relative;
  }

  .carousel-frame :deep(.carousel-nav-button) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin: 0 !important;
    z-index: 4;
  }

  .carousel-frame :deep(.carousel-nav-button.prev) {
    left: 16px;
  }

  .carousel-frame :deep(.carousel-nav-button.next) {
    right: 16px;
  }

  .carousel-frame :deep(.carousel-nav-button:hover:not(:disabled)) {
    transform: translateY(-50%) scale(1.06);
  }

  /* === Banda de servicios === */
  .services-band {
    background: linear-gradient(135deg, #734A91 0%, #65209D 100%);
    min-height: 360px;
  }

  .services-band-pattern {
    position: absolute;
    inset: 0;
    background-image:
      radial-gradient(rgba(255, 255, 255, 0.08) 1px, transparent 1px),
      radial-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px);
    background-size: 28px 28px, 14px 14px;
    background-position: 0 0, 14px 14px;
    opacity: 0.6;
    pointer-events: none;
  }

  /* === Service cards === */
  .service-card {
    background: #ffffff;
    border-radius: 1.5rem;
    padding: 0 0 2rem;
    text-align: center;
    box-shadow: 0 6px 24px rgba(17, 12, 24, 0.06);
    border: 1px solid rgba(184, 177, 189, 0.25);
  }

  /* Padding lateral sólo para el texto, la imagen queda borde a borde */
  .service-card > :not(.service-card-media) {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .service-card-media {
    position: relative;
    border-radius: 1.5rem 1.5rem 0 0;
    overflow: hidden;
    aspect-ratio: 4 / 5;
    margin-bottom: 3rem;
  }

  .service-card-media::after {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    box-shadow: inset 0 -110px 80px -80px rgba(115, 74, 145, 0.22);
    border-radius: 1.5rem 1.5rem 0 0;
    z-index: 2;
  }

  .service-card-media :deep(.carousel-container),
  .service-card-media :deep(.carousel-viewport),
  .service-card-media :deep(.slide-personalizado) {
    height: 100%;
  }

  .service-card-media :deep(.carousel-slides) {
    height: 100%;
  }

  .service-card-media :deep(.slide-personalizado) {
    padding: 0;
  }

  .service-card-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0;
    animation: kenburns 9s ease-in-out infinite alternate;
    transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
  }

  @keyframes kenburns {
    from { transform: scale(1) translate(0, 0); }
    to   { transform: scale(1.06) translate(-1%, -1%); }
  }

  .service-card:hover .service-card-img {
    animation-play-state: paused;
    transform: scale(1.08);
  }

  /* Carrusel embebido en la card: flechas flotantes sobre la imagen */
  .service-card-media :deep(.carousel-container) {
    position: relative;
  }

  .service-card-media :deep(.carousel-nav-button) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin: 0 !important;
    width: 40px;
    height: 40px;
    z-index: 4;
  }

  .service-card-media :deep(.carousel-nav-button.prev) {
    left: 12px;
  }

  .service-card-media :deep(.carousel-nav-button.next) {
    right: 12px;
  }

  .service-card-media :deep(.carousel-nav-button:hover:not(:disabled)) {
    transform: translateY(-50%) scale(1.06);
  }

  /* Paginación del carrusel dentro de las service-cards */
  .service-card-media :deep(.carousel-pagination) {
    bottom: -28px;
    background: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    padding: 0;
    z-index: 3;
  }

  .service-card-media :deep(.carousel-pagination button) {
    background-color: rgba(184, 177, 189, 0.55);
    width: 7px;
    height: 7px;
  }

  .service-card-media :deep(.carousel-pagination button:hover:not(.active)) {
    background-color: rgba(115, 74, 145, 0.6);
  }

  .service-card-media :deep(.carousel-pagination button.active) {
    background-color: #734A91;
    width: 22px;
  }

  /* === Quien soy band === */
  .quien-soy-band {
    background: linear-gradient(135deg, #b8b1bd 0%, #a39bab 100%);
    margin-top: 6rem;
  }

  .quien-soy-band::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(rgba(255, 255, 255, 0.18) 1px, transparent 1px);
    background-size: 20px 20px;
    opacity: 0.35;
    pointer-events: none;
  }

  .portrait-frame {
    position: relative;
    width: 360px;
    height: 360px;
  }

  .portrait-frame::before {
    content: '';
    position: absolute;
    inset: -14px -14px 14px 14px;
    border: 2px solid rgba(255, 255, 255, 0.85);
    border-radius: 9999px;
    z-index: 1;
  }

  .portrait-image {
    width: 100%;
    height: 100%;
    border-radius: 9999px;
    object-fit: cover;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.18);
    position: relative;
    z-index: 2;
  }

  .map-wrapper {
    position: relative;
    border-radius: 1.25rem;
    overflow: hidden;
    box-shadow: 0 18px 40px rgba(115, 74, 145, 0.15);
    border: 1px solid rgba(184, 177, 189, 0.35);
  }

  @media (max-width: 640px) {
    .portrait-frame {
      width: 280px;
      height: 280px;
    }
  }
  </style>
  
